// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .navbar {
    background-color: #1f5156;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    position: sticky;
    top: 0;
    z-index: 20;
  }
  
  .nav-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 80px;
    max-width: auto;
    position: relative;
  }
  
  .nav-logo {
    color: #f5b921;
    align-items: center;
    margin-left: 20px;
    cursor: pointer;
    text-decoration: none;
    font-size: 2rem;
    flex-grow: 1;
  
    display: flex;
    align-items: left;
    justify-items: left;
  }
  
  .nav-logo .icon {
    display: inline-block;
    width: 3rem;
    height: 3rem;
    margin-left: 16px;
  }
  
  .nav-menu {
    display: flex;
    list-style: none;
    text-align: center;
    margin-right: 2rem;
  }
  
  .nav-links {
    color: #fff;
    text-decoration: none;
    padding: 0.5rem 1rem;
    height: 100%;
    border-bottom: 3px solid transparent;
  }
  
  .nav-item {
    line-height: 40px;
    margin-right: 1rem;
  }
  
  .nav-item:after {
    content: "";
    display: block;
    height: 3px;
    width: 0;
    background: transparent;
    transition: width 0.7s ease, background-color 0.5s ease;
  }
  
  .nav-item:hover:after {
    width: 100%;
    background: #ffdd40;
  }
  
  .nav-item .active {
    color: #ffdd40;
    border: 1px solid #ffdd40;
  }
  
  .nav-icon {
    display: none;
    color: #f5b921;
  }
  
  .nav-icon .icon {
    display: inline-block;
    width: 2rem;
    height: 2rem;
  }
  
  @media screen and (max-width: 960px) {
    .nav-menu {
      display: flex;
      flex-direction: column;
      width: 100%;
      border-top: 1pxsolid #fff;
      position: absolute;
      top: 80px;
      left: -110%;
      opacity: 1;
      transition: all 0.5s ease;
    }
  
    .nav-menu.active {
      background: #1f5156;
      left: 0px;
      opacity: 1;
      transition: all 0.5s ease;
      z-index: 1;
    }
    .nav-item .active {
      color: #ffdd40;
      border: none;
    }
    .nav-links {
      padding: 1.5rem;
      width: 100%;
      display: table;
    }
  
    .nav-logo .icon {
      width: 2rem;
      height: 2rem;
    }
  
    .nav-icon {
      display: block;
      position: absolute;
      top: 50%;
      right: 0;
      transform: translate(-100%, -50%);
      width: 2rem;
      height: 2rem;
      cursor: pointer;
      color: #ffdd40;
    }
  } */

  .navbar.sidebar {
    background-color: #1f5156;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    font-size: 1.2rem;
    position: fixed;
    top: 0;
    left: 0;
    right: 20%;
    z-index: 20;
    width: 250px;
    transition: width 0.5s ease;
  }
  
  .navbar.sidebar-hidden {
    width: 0;
    /* left: -250px; */
    transition: width 0.5s ease, left 0.5s ease;
    overflow: hidden;
  }
  
  .nav-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    padding-top: 20px;
  }
  
  .nav-logo {
    color: #f5b921;
    margin-left: 20px;
    cursor: pointer;
    text-decoration: none;
    font-size: 2rem;
    display: flex;
    align-items: center;
    margin-bottom: 2rem;
  }
  
  .nav-logo .icon {
    display: inline-block;
    width: 3rem;
    height: 3rem;
    margin-left: 16px;
  }
  
  .nav-menu {
    display: flex;
    flex-direction: column;
    list-style: none;
    width: 100%;
    padding-left: 0;
  }
  
  .nav-menu.active {
    display: flex;
  }
  
  .nav-links {
    color: #fff;
    text-decoration: none;
    padding-top: 1rem;
    padding-bottom: 1rem;
    padding-left: 0.1rem;
    text-align: center;
    width: 100%;
    display: block;
    border-bottom: 1px solid transparent;
  }
  
  .nav-item {
    width: 100%;
  }
  
  .nav-item:hover .nav-links {
    background-color: #ffdd40;
    color: #1f5156;
  }
  
  .nav-item .active {
    color: #ffdd40;
    border: none;
  }
  
  .nav-icon {
    display: none;
    color: #f5b921;
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }
  
  .nav-icon .icon {
    display: inline-block;
    width: 2rem;
    height: 2rem;
  }
  
  .toggle-button {
    position: absolute;
    top: 20px;
    /* right: -30px; */
    right: -10%;
    background-color: #1f5156;
    color: #f5b921;
    padding: 10px;
    cursor: pointer;
    font-size: 1.2rem;
    border-radius: 5px;
  }

  .toggle-button-hidden{
    /* right: -10%; */
    position: absolute;
    top: 20px;
    background-color: #1f5156;
    color: #f5b921;
    padding: 10px;
    cursor: pointer;
    font-size: 1.2rem;
    border-radius: 5px;
  }
  
  @media screen and (max-width: 960px) {
    .nav-icon {
      display: block;
    }
  
    .nav-menu {
      position: absolute;
      top: 0;
      left: -250px;
      width: 250px;
      height: 100%;
      background-color: #1f5156;
      transition: left 0.5s ease;
      z-index: 1;
    }
  
    .nav-menu.active {
      left: 0;
    }
  
    .nav-links {
      padding: 1.5rem;
    }
  
    .nav-logo .icon {
      width: 2rem;
      height: 2rem;
    }
  
    .toggle-button {
      top: 20px;
      right: -40px; /* Adjust to position the toggle button correctly */
    }
  }

  .nav-logo-container {
    margin-top: 100%; 
    /* padding: 20px; */
    text-align: center;
    /* height: 100%; */
    display: flex;
    flex-direction: column;
    gap: 11%;
    padding: 10%;
    height: 72%;
  }
  
  .nav-logo-img {
    width: 100%; /* Adjust size as needed */
    height: auto;
    /* max-width: 200px; */
    /* max-height: 200px; */
  }
  
  .nav-logo-img-2{
    width: 100%; /* Adjust size as needed */
    height: auto;
  }`, "",{"version":3,"sources":["webpack://./src/components/NavBar.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KA2IK;;EAEH;IACE,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,MAAM;IACN,OAAO;IACP,UAAU;IACV,WAAW;IACX,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,QAAQ;IACR,kBAAkB;IAClB,2CAA2C;IAC3C,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,oCAAoC;EACtC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE;MACE,cAAc;IAChB;;IAEA;MACE,kBAAkB;MAClB,MAAM;MACN,YAAY;MACZ,YAAY;MACZ,YAAY;MACZ,yBAAyB;MACzB,0BAA0B;MAC1B,UAAU;IACZ;;IAEA;MACE,OAAO;IACT;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,SAAS;MACT,YAAY,EAAE,mDAAmD;IACnE;EACF;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW,EAAE,0BAA0B;IACvC,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW,EAAE,0BAA0B;IACvC,YAAY;EACd","sourcesContent":["/* .navbar {\n    background-color: #1f5156;\n    height: 80px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 1.2rem;\n    position: sticky;\n    top: 0;\n    z-index: 20;\n  }\n  \n  .nav-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 80px;\n    max-width: auto;\n    position: relative;\n  }\n  \n  .nav-logo {\n    color: #f5b921;\n    align-items: center;\n    margin-left: 20px;\n    cursor: pointer;\n    text-decoration: none;\n    font-size: 2rem;\n    flex-grow: 1;\n  \n    display: flex;\n    align-items: left;\n    justify-items: left;\n  }\n  \n  .nav-logo .icon {\n    display: inline-block;\n    width: 3rem;\n    height: 3rem;\n    margin-left: 16px;\n  }\n  \n  .nav-menu {\n    display: flex;\n    list-style: none;\n    text-align: center;\n    margin-right: 2rem;\n  }\n  \n  .nav-links {\n    color: #fff;\n    text-decoration: none;\n    padding: 0.5rem 1rem;\n    height: 100%;\n    border-bottom: 3px solid transparent;\n  }\n  \n  .nav-item {\n    line-height: 40px;\n    margin-right: 1rem;\n  }\n  \n  .nav-item:after {\n    content: \"\";\n    display: block;\n    height: 3px;\n    width: 0;\n    background: transparent;\n    transition: width 0.7s ease, background-color 0.5s ease;\n  }\n  \n  .nav-item:hover:after {\n    width: 100%;\n    background: #ffdd40;\n  }\n  \n  .nav-item .active {\n    color: #ffdd40;\n    border: 1px solid #ffdd40;\n  }\n  \n  .nav-icon {\n    display: none;\n    color: #f5b921;\n  }\n  \n  .nav-icon .icon {\n    display: inline-block;\n    width: 2rem;\n    height: 2rem;\n  }\n  \n  @media screen and (max-width: 960px) {\n    .nav-menu {\n      display: flex;\n      flex-direction: column;\n      width: 100%;\n      border-top: 1pxsolid #fff;\n      position: absolute;\n      top: 80px;\n      left: -110%;\n      opacity: 1;\n      transition: all 0.5s ease;\n    }\n  \n    .nav-menu.active {\n      background: #1f5156;\n      left: 0px;\n      opacity: 1;\n      transition: all 0.5s ease;\n      z-index: 1;\n    }\n    .nav-item .active {\n      color: #ffdd40;\n      border: none;\n    }\n    .nav-links {\n      padding: 1.5rem;\n      width: 100%;\n      display: table;\n    }\n  \n    .nav-logo .icon {\n      width: 2rem;\n      height: 2rem;\n    }\n  \n    .nav-icon {\n      display: block;\n      position: absolute;\n      top: 50%;\n      right: 0;\n      transform: translate(-100%, -50%);\n      width: 2rem;\n      height: 2rem;\n      cursor: pointer;\n      color: #ffdd40;\n    }\n  } */\n\n  .navbar.sidebar {\n    background-color: #1f5156;\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    font-size: 1.2rem;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 20%;\n    z-index: 20;\n    width: 250px;\n    transition: width 0.5s ease;\n  }\n  \n  .navbar.sidebar-hidden {\n    width: 0;\n    /* left: -250px; */\n    transition: width 0.5s ease, left 0.5s ease;\n    overflow: hidden;\n  }\n  \n  .nav-container {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n    height: 100%;\n    padding-top: 20px;\n  }\n  \n  .nav-logo {\n    color: #f5b921;\n    margin-left: 20px;\n    cursor: pointer;\n    text-decoration: none;\n    font-size: 2rem;\n    display: flex;\n    align-items: center;\n    margin-bottom: 2rem;\n  }\n  \n  .nav-logo .icon {\n    display: inline-block;\n    width: 3rem;\n    height: 3rem;\n    margin-left: 16px;\n  }\n  \n  .nav-menu {\n    display: flex;\n    flex-direction: column;\n    list-style: none;\n    width: 100%;\n    padding-left: 0;\n  }\n  \n  .nav-menu.active {\n    display: flex;\n  }\n  \n  .nav-links {\n    color: #fff;\n    text-decoration: none;\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n    padding-left: 0.1rem;\n    text-align: center;\n    width: 100%;\n    display: block;\n    border-bottom: 1px solid transparent;\n  }\n  \n  .nav-item {\n    width: 100%;\n  }\n  \n  .nav-item:hover .nav-links {\n    background-color: #ffdd40;\n    color: #1f5156;\n  }\n  \n  .nav-item .active {\n    color: #ffdd40;\n    border: none;\n  }\n  \n  .nav-icon {\n    display: none;\n    color: #f5b921;\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    cursor: pointer;\n  }\n  \n  .nav-icon .icon {\n    display: inline-block;\n    width: 2rem;\n    height: 2rem;\n  }\n  \n  .toggle-button {\n    position: absolute;\n    top: 20px;\n    /* right: -30px; */\n    right: -10%;\n    background-color: #1f5156;\n    color: #f5b921;\n    padding: 10px;\n    cursor: pointer;\n    font-size: 1.2rem;\n    border-radius: 5px;\n  }\n\n  .toggle-button-hidden{\n    /* right: -10%; */\n    position: absolute;\n    top: 20px;\n    background-color: #1f5156;\n    color: #f5b921;\n    padding: 10px;\n    cursor: pointer;\n    font-size: 1.2rem;\n    border-radius: 5px;\n  }\n  \n  @media screen and (max-width: 960px) {\n    .nav-icon {\n      display: block;\n    }\n  \n    .nav-menu {\n      position: absolute;\n      top: 0;\n      left: -250px;\n      width: 250px;\n      height: 100%;\n      background-color: #1f5156;\n      transition: left 0.5s ease;\n      z-index: 1;\n    }\n  \n    .nav-menu.active {\n      left: 0;\n    }\n  \n    .nav-links {\n      padding: 1.5rem;\n    }\n  \n    .nav-logo .icon {\n      width: 2rem;\n      height: 2rem;\n    }\n  \n    .toggle-button {\n      top: 20px;\n      right: -40px; /* Adjust to position the toggle button correctly */\n    }\n  }\n\n  .nav-logo-container {\n    margin-top: 100%; \n    /* padding: 20px; */\n    text-align: center;\n    /* height: 100%; */\n    display: flex;\n    flex-direction: column;\n    gap: 11%;\n    padding: 10%;\n    height: 72%;\n  }\n  \n  .nav-logo-img {\n    width: 100%; /* Adjust size as needed */\n    height: auto;\n    /* max-width: 200px; */\n    /* max-height: 200px; */\n  }\n  \n  .nav-logo-img-2{\n    width: 100%; /* Adjust size as needed */\n    height: auto;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
